import { render, staticRenderFns } from "./NewSurveyPage.vue?vue&type=template&id=4242931e&scoped=true"
import script from "./NewSurveyPage.vue?vue&type=script&lang=js"
export * from "./NewSurveyPage.vue?vue&type=script&lang=js"
import style0 from "./NewSurveyPage.vue?vue&type=style&index=0&id=4242931e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4242931e",
  null
  
)

export default component.exports